import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient} from '@angular/common/http';
import { Util } from '../util.service';

@Injectable({
  providedIn: 'root'
})
export class SupervisorService {
  baseurl = Util.GetBaseUrl();

  constructor(private http: HttpClient, public router: Router) { }

  viewSupervisor() {
    return this.http.get(this.baseurl +'/api/Supervisors/GetSupervisors')
  }

  addSupervisor(supervisorForm) {
    console.log(supervisorForm);
    return this.http.post(this.baseurl+'/api/Supervisors', supervisorForm)
  }

  editSupervisor(id, supervisorForm) {
    console.log(supervisorForm);
    return this.http.put(this.baseurl +`/api/Supervisors/${id}`, supervisorForm)
  }

  deleteSupervisor(id) {
    console.log(id);
    return this.http.delete(this.baseurl+`/api/Supervisors/${id}`)
  }
}
